import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBQ3jdYK0YlpjuY0JH3AWoo6r-DIcI_l4I",
  authDomain: "dev-safelet.firebaseapp.com",
  databaseURL: "https://dev-safelet-default-rtdb.firebaseio.com",
  projectId: "dev-safelet",
  storageBucket: "dev-safelet.firebasestorage.app",
  messagingSenderId: "589008625602",
  appId: "1:589008625602:web:8486a22ce29e0feadf005b",
  measurementId: "G-ECJRXYLCR5"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getFcmToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: 'BMeFuAMvVf-eXx_NmNPKlLtccS2mSl0Xo0XLMILPowfm2ZB_jMGEEdsySJ5O2rWQLdRy1evvgt_rquBJ6IKyR_o',
    });

    if (currentToken) {
      console.log('✅ FCM Token:', currentToken);
      return currentToken;
    } else {
      console.warn('❌ No registration token available. Request permission to generate one.');
      return null;
    }
  } catch (err) {
    console.error('❌ An error occurred while retrieving token.', err);
    return null;
  }
};
